import React from 'react';
import { SupraAccessBenefitSVG } from '@bb/elements-web';
import {
  SupraSubscriptionProductBillingModel,
  SupraSystemSubscriptionType,
} from '@bb/domain/dist/types';
import { camelCase, startCase } from 'lodash';
import SubscriptionCard from './SubscriptionCard';

export interface SupraOneCardProps {
  /** Whether there was an error fetching who pays for the Supra One subscription. */
  fetchDataError?: boolean;
  /** Whether the user is subscribed to a Supra One access key */
  isSubscribed: boolean;
  /** The key type of the Supra One subscription this user is subscribed to. */
  supraSubscriptionType?: SupraSystemSubscriptionType;
  /** How the subscription is billed - affects text next to status pill */
  supraSubscriptionPayer?: SupraSubscriptionProductBillingModel;
  /** Callback when button is clicked */
  onButtonClick?: () => void;
}

/** The text to show next to the status label */
const billingTypeLabels: Record<SupraSubscriptionProductBillingModel, string> =
  {
    Board: 'Managed by Organization',
    User: '',
  };

/**
 * The card displaying information about the user's
 * Supra One subscription. (Or lack thereof.)
 */
const SupraOneCard: React.FC<SupraOneCardProps> = ({
  fetchDataError,
  isSubscribed = false,
  supraSubscriptionType,
  supraSubscriptionPayer,
  onButtonClick,
}) => {
  const handleClick = () => {
    onButtonClick?.();
  };

  /** The config we pass in depending on whether they are subscribed or not */
  const config = isSubscribed
    ? {
        planName: `Supra Access - ${startCase(camelCase(supraSubscriptionType))} Key`,
        description:
          'Access properties and manage your Supra lockboxes directly from your mobile device.',
        statusText: 'Active',
        isUpgradeAvailable: false,
      }
    : {
        planName: 'Supra Access',
        description:
          'Access properties and manage your lockboxes directly from your device.\nReach out to your organization to subscribe.',
        statusText: '',
        isUpgradeAvailable: true,
      };
  const managedByText = billingTypeLabels[supraSubscriptionPayer];

  return (
    <SubscriptionCard
      fetchDataError={fetchDataError}
      isSubscribed={isSubscribed}
      allowedToSelfUpgrade={false}
      statusText={config.statusText}
      image={<SupraAccessBenefitSVG />}
      isUpgradeAvailable={config.isUpgradeAvailable}
      managedByText={managedByText}
      upgradeText="Subscribe by contacting your organization"
      planName={config.planName}
      description={config.description}
      onButtonClick={handleClick}
    />
  );
};

export default SupraOneCard;
